import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';

console.log('Rendering BlogPreview');

const BlogPreview = () => {
  const recentPosts = [
  {
    id: 1,
    title: "Building Scalable Real-Time Systems with WebSocket",
    excerpt: "Learn how to architect WebSocket infrastructure that handles thousands of concurrent connections while maintaining low latency and high reliability.",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_18f39eeed-1766834797204.png",
    imageAlt: "Developer working on laptop showing real-time data streaming dashboard with colorful graphs and network connections in modern office",
    category: "Architecture",
    readTime: "8 min read",
    date: "Dec 28, 2025",
    tags: ["WebSocket", "Node.js", "Scalability"]
  },
  {
    id: 2,
    title: "Optimizing React Performance: Beyond the Basics",
    excerpt: "Deep dive into advanced React optimization techniques including code splitting, lazy loading, and effective use of useMemo and useCallback hooks.",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_118aca1f6-1766470715182.png",
    imageAlt: "Computer screen displaying React code with performance profiling tools showing component render times and optimization metrics",
    category: "Frontend",
    readTime: "10 min read",
    date: "Dec 25, 2025",
    tags: ["React", "Performance", "Optimization"]
  },
  {
    id: 3,
    title: "Microservices Security: Best Practices for 2025",
    excerpt: "Comprehensive guide to securing microservices architecture with JWT authentication, API gateways, and service mesh implementation.",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_149a9ce36-1764660286790.png",
    imageAlt: "Digital security concept showing encrypted data flow between microservices with lock icons and network nodes on dark blue background",
    category: "Security",
    readTime: "12 min read",
    date: "Dec 22, 2025",
    tags: ["Security", "Microservices", "JWT"]
  }];


  return (
    <section className="py-16 md:py-20 lg:py-24 bg-card">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 mb-12 md:mb-16">
          <div>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold font-heading text-foreground mb-2">
              Technical Insights
            </h2>
            <p className="text-base md:text-lg text-muted-foreground">
              Sharing knowledge from real-world production experience
            </p>
          </div>
          <Button
            variant="outline"
            size="lg"
            iconName="BookOpen"
            iconPosition="right"
            asChild>

            <Link to="/technical-blog">View All Posts</Link>
          </Button>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {recentPosts?.map((post) =>
          <article
            key={post?.id}
            className="group bg-background rounded-xl overflow-hidden border border-border hover:border-primary/50 transition-all duration-300 hover:shadow-xl">

              <div className="relative aspect-[16/10] overflow-hidden">
                <Image
                src={post?.image}
                alt={post?.imageAlt}
                className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" />

                <div className="absolute top-4 left-4">
                  <span className="px-3 py-1 text-xs font-medium bg-primary text-primary-foreground rounded-full">
                    {post?.category}
                  </span>
                </div>
              </div>

              <div className="p-4 md:p-6">
                <div className="flex items-center gap-4 text-xs md:text-sm text-muted-foreground mb-3">
                  <div className="flex items-center gap-1">
                    <Icon name="Calendar" size={14} />
                    <span>{post?.date}</span>
                  </div>
                  <div className="flex items-center gap-1">
                    <Icon name="Clock" size={14} />
                    <span>{post?.readTime}</span>
                  </div>
                </div>

                <h3 className="text-lg md:text-xl font-bold text-foreground mb-3 line-clamp-2 group-hover:text-primary transition-colors duration-300">
                  {post?.title}
                </h3>

                <p className="text-sm md:text-base text-muted-foreground mb-4 line-clamp-3">
                  {post?.excerpt}
                </p>

                <div className="flex flex-wrap gap-2 mb-4 pb-4 border-b border-border">
                  {post?.tags?.map((tag) =>
                <span
                  key={tag}
                  className="px-2 py-1 text-xs bg-muted text-muted-foreground rounded">

                      #{tag}
                    </span>
                )}
                </div>

                <Link
                to="/technical-blog"
                className="inline-flex items-center gap-2 text-sm font-medium text-primary hover:gap-3 transition-all duration-300">

                  <span>Read Article</span>
                  <Icon name="ArrowRight" size={16} />
                </Link>
              </div>
            </article>
          )}
        </div>
      </div>
    </section>);

};

export default BlogPreview;